Controller = App.loadClass 'core::Angular/Controller'

class exports.ConfirmationController extends Controller
    constructor: (@scope, @transitions, @state, @generate, @window, @timeout) ->
        super(@scope, @transitions)
        # Variable Declarations
        # ui controls
        @scope.ui = {
            table:
                columns: false
                belongs_to: false
            loaded: false
            info_text: 'Please select a tab.'
        }
        # Array indexed by parent rows id that determines whether or not children are hidden
        @scope.children_hidden = []
        # Container for table row data
        @scope.rows = []

        # Function Declarations
        @scope.tabSwitch = @tabSwitch
        @scope.tabs = {}
        @window.inputFileProcessed = @inputFileProcessed
        @window.conversionRequestSent = @conversionRequestSent
        @scope.close = @close
        @checkForDataByTab()

        @scope.$on 'uploads:processing', () =>
            @state.go('^') if @state.current.url isnt '/confirmation' and @state.current.name.includes('confirm')
            @checkForDataByTab()

        @scope.$on '$destroy', () =>
            if @state.includes('grower.data.view')
                @scope.$emit 'data_fullpage:hide'
            App.sidebar?.open()
            App.angularSidebar?.open()

    close: () =>
        @scope.$emit 'data_fullpage:hide'
        App.sidebar?.open()
        App.angularSidebar?.open()
        return

    conversionRequestSent: (data) =>
        @scope.$emit 'uploads:processing'

    checkForDataByTab: () =>
        @generate.checkForDataByTab().then (response) =>
            if response.data.status.type = 'success'
                # determine which tabs to show
                @processTabData(response.data.data.counts)
                # handle disables
                if not response.data.data.processing.finished
                    @handleProcessing(response.data.data.processing)
                else
                    @scope.tabs['processing'] = false
                    @handleAutoSelect()

    inputFileProcessed: (data) =>
        @generate.checkForDataByTab().then (response) =>
            @processTabData(response.data.data.counts)
            @handleProcessing(response.data.data.processing)

    handleProcessing: (data) =>
        @scope.processing = data.processing
        @scope.total = data.total
        @scope.processed = @scope.total - @scope.processing
        @scope.tabs['processing'] = if data.finished then false else true

        if data.finished
            @scope.tabs['processing'] = false
            @scope.ui.info_text = 'Please select a tab.'
        else
            @scope.tabs['processing'] = true
            @scope.ui.info_text = 'Uploaded data is still processing.
            Tabs will be available once all data has finished processing.'

    processTabData: (counts) =>
        for tab, data of counts
            @setTabData(tab, data)

    handleAutoSelect: () =>
        if @countValidTabs() is 1
            for tab, obj of @scope.tabs
                @tabSwitch(tab) if obj.data

    countValidTabs: () =>
        valid = 0

        for tab, obj of @scope.tabs
            valid += 1 if obj.data

        return valid

    tabSwitch: (tab) =>
        if tab in ['management_zone', 'mmz']
            @activateTab('mmz')

        @activateTab(tab)

    activateTab: (tab) =>
        # we must use a timeout or the tab will not get the "active" class
        @timeout () =>
            @state.go("grower.data.add.upload.confirm.#{tab}")
        , 100

    setTabData: (tab, data) =>
        if tab is 'Yield'
            @scope.tabs['yield'] = @checkTabData(data)
        if tab is 'As-Planted'
            @scope.tabs['planting'] = @checkTabData(data)
        if tab is 'Management Zone'
            @scope.tabs['mmz'] = @checkTabData(data)

    checkTabData: (data) =>
        if data.unconfirmed
            return { unconfirmed: true, data: true }

        return { unconfirmed: false, data: data.all > 0 }
